import { Services } from '@sigma-frontend-libs/commons'

import { components, getIconSVGByType } from '@/utils'

import squircle from '@/components/icon/squircle'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderSelection(h, item) {
  const props = {
    label: item.name,
    as: 'select'
  }
  if (this.dense) {
    props.as = 'select-dense'
  }
  if (item.type) {
    const iconSVG = getIconSVGByType(item.type)
    props.tooltip = this.getTranslate(`${Services.sendings}.types.${iconSVG}`)
    props.color = iconSVG
  }

  return h(tag, { props })
}
function renderItemIcon(h, item) {
  const iconSVG = getIconSVGByType(item.type)

  return h(
    squircle,
    {
      props: {
        iconSVG,
        iconSize: 18,
        color: iconSVG,
        tooltip: this.getTranslate(`${Services.sendings}.types.${item.type}`)
      }
    }
  )
}
function renderItemInfo(h, item) {
  return h(
    'div',
    {
      class: 'selector-sendername__item-info'
    },
    [
      h(
        textOverflow,
        {
          props: { value: item.name }
        }
      ),
      h(
        textOverflow,
        {
          class: 'selector-sendername__item-hint',
          props: { value: item.id }
        }
      )
    ]
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: 'selector-sendername__item'
    },
    [
      renderItemIcon.call(this, h, item),
      renderItemInfo.call(this, h, item)
    ]
  )
}
function renderListItem(h, item, toggleByValue) {
  const active = item.id === this.selectedId

  return h(
    components['list-item'],
    {
      props: {
        active,
        hovered: item._hovered,
        disabled: item._disabled || active,
        dense: this.dense
      },
      on: {
        click: () => {
          this.handleItemClick(item, toggleByValue)
        }
      }
    },
    [ renderItem.call(this, h, item) ]
  )
}

export default function(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.label || this.getTranslate(`${Services.sendings}.labels.sender`),
        labelMode: this.labelMode,
        service: Services.sendernames,
        query: this.query,
        itemsPrepend: this.itemsPrepend,
        itemsDisabled: this.itemsDisabled,
        itemTitle: 'name',
        itemValue: this.itemValue,
        picks: [ 'id', 'name', 'type' ],
        error: this.errors.sender,
        loading: this.$_loading,
        disabled: this.disabled,
        readonly: this.readonly,
        required: this.required,
        setRequiredOnMounted: this.setRequiredOnMounted,
        combobox: this.$_combobox,
        clearable: this.clearable,
        dense: this.dense,
        multiple: this.multiple,
        setOnBlur: true,
        autocomplete: true,
        details: false
      },
      on: {
        input: this.handleInput,
        search: this.handleSearch,
        fetched: this.handleFetched
      },
      scopedSlots: {
        selection: ({ item }) => {
          return renderSelection.call(this, h, item)
        },
        listItem: ({ item, toggleByValue }) => {
          return renderListItem.call(this, h, item, toggleByValue)
        }
      }
    }
  )
}
